import type { GeneralTokenCollectionType } from "@/features/bridge/types/open-sea-api.types";

export const collectionContains = (collection: GeneralTokenCollectionType) => {
  return Object.keys(collection).length;
};
